import { render, staticRenderFns } from "./PostLoginRegistrationForm.vue?vue&type=template&id=7d44b6c2&scoped=true"
import script from "./PostLoginRegistrationForm.vue?vue&type=script&lang=js"
export * from "./PostLoginRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d44b6c2",
  null
  
)

export default component.exports